/** @format */

import axios from 'axios'

import { notification } from 'antd'

import { ENV_COUNTRY, ENV_FUNCTION_USER } from '../../../hooks/enviroment'

export async function serviceUserRecover(item) {
	return await axios({
		method: 'POST',
		url: `${ENV_FUNCTION_USER}/user/restore-password/${ENV_COUNTRY}`,
		data: {
			email: item.email,
		},
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				notification['success']({
					message: 'Contraseña Enviada',
					description: 'Su contraseña nueva fue enviada a su correo electrónico.',
				})
			} else {
				notification['error']({
					message: 'Problema con Email',
					description: 'Verifique que su correo correo electrónico este regisrado.',
				})
			}
			return response.data
		})
		.catch((error) => {
			notification['error']({
				message: `Error Servicio ${error.response.status}`,
				description: `${ENV_FUNCTION_USER}/user/restore-password/${ENV_COUNTRY}`,
			})
			return error.response.data
		})
}
